import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { Translate, useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';

import { GenerateMZ15FormBean, GenerateMZ15FormController } from './GenerateMZ15Form.types';
import { ReportingPeriodSelect } from './fields/ReportingPeriodSelect';
import { IncludeVisitsFinishedNotApprovedCheckbox } from './fields/IncludeVisitsFinishedNotApprovedCheckbox';
import { IncludeVisitsInProgressCheckbox } from './fields/IncludeVisitsInProgressCheckbox';
import { HealthcareProviderLocationSelect } from './fields/HealthcareProviderLocationSelect';

type GenerateMZ15FormRenderProps = Pick<GenerateMZ15FormController, 'handleSubmit' | 'formState'>;

type GenerateMZ15FormProps = {
   readonly healthcareProviderLocations: HealthcareProviderLocation[];
   readonly children: (renderProps: GenerateMZ15FormRenderProps) => JSX.Element;
};

export const GenerateMZ15Form = (props: GenerateMZ15FormProps): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<GenerateMZ15FormBean>({
      year: new Date().getFullYear() - 1,
      healthcareProviderLocation: null,
   });

   return (
      <StyledFlex as={'form'} direction={'column'} gap={'24px'}>
         <Translate>{statisticsTranslationKeys.modal.type.healthcareProviderMZ15}</Translate>

         <ReportingPeriodSelect register={register} />
         <HealthcareProviderLocationSelect
            register={register}
            healthcareProviderLocations={props.healthcareProviderLocations}
         />
         <IncludeVisitsFinishedNotApprovedCheckbox register={register} />
         <IncludeVisitsInProgressCheckbox register={register} />

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </StyledFlex>
   );
};
